// cSpell:ignore useractive userinactive
import { useEffect, useState } from "react";

import type Player from "video.js/dist/types/player";

/**
 * video.js の useractive / userinactive イベントを監視し、
 * ユーザーがアクティブかどうかを返す
 */
export const usePlayerUserActive = (player: Player): boolean => {
  const [isUserActive, setIsUserActive] = useState(true);

  useEffect(() => {
    const onUserActive = () => setIsUserActive(true);
    const onUserInactive = () => setIsUserActive(false);

    player.on("useractive", onUserActive);
    player.on("userinactive", onUserInactive);

    return () => {
      player.off("useractive", onUserActive);
      player.off("userinactive", onUserInactive);
    };
  }, [player]);

  return isUserActive;
};
